var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { candidateApplyJob, saveCustomerJobs } from '@/api';
import { ApplyJobModal, Button, ConformationModal, DayChip, JobActions, JobMetadata, JobTitleName, NotRegisteredModal, } from '@/components';
import { useConfigContext, useCustomerDetailContext, useToast } from '@/hoc';
import { useMutation } from '@/hooks';
import { convertUTCDateToLocalDate, formatDate, getJobQuery } from '@/utils';
import { useState } from 'react';
var defaultVoidFunction = function () {
    return;
};
export var SkillsList = function (_a) {
    var skills = _a.skills, isSkillChipFilterable = _a.isSkillChipFilterable;
    var _b = useState(false), allSkillVisible = _b[0], setAllSkillVisible = _b[1];
    var jobListingPageUrl = useConfigContext().config.jobListingPageUrl;
    if (!(skills === null || skills === void 0 ? void 0 : skills.length))
        return null;
    return (_jsxs("div", { className: 'flex flex-wrap gap-1', children: [(allSkillVisible ? skills : skills.slice(0, 6)).map(function (skill) { return (_jsx("div", { onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (isSkillChipFilterable) {
                        window.sessionStorage.setItem('jobFilters', JSON.stringify({
                            appliedFilters: [
                                {
                                    label: skill.skill_name,
                                    value: skill.skill_id,
                                    queryKey: 'skill',
                                },
                            ],
                        }));
                        window.location.href = jobListingPageUrl !== null && jobListingPageUrl !== void 0 ? jobListingPageUrl : '/';
                    }
                }, className: 'px-1 rounded-full border-2 border-vjwPrimary text-vjwPrimary text-xs hover:bg-blue-50 cursor-pointer', children: skill.skill_name }, skill.skill_id)); }), skills.length > 6 && (_jsx(Button, { variant: 'text', onClick: function () { return setAllSkillVisible(!allSkillVisible); }, className: 'text-vjwPrimary hover:underline text-xs px-0 py-0', children: allSkillVisible ? 'Show Less' : "+".concat(skills.length - 6, " More") }))] }));
};
export var SimilarJobCard = function (_a) {
    var jobDetails = _a.jobDetails, refetchJobs = _a.refetchJobs, handleUpdateJobDetails = _a.handleUpdateJobDetails;
    var _b = useState(''), variableForModal = _b[0], setVariableForModal = _b[1];
    var _c = useState(false), applyModalVisible = _c[0], setApplyModalVisible = _c[1];
    var _d = useState(null), selectedJobId = _d[0], setSelectedJobId = _d[1];
    var customerDetail = useCustomerDetailContext().customerDetail;
    var showToast = useToast().showToast;
    var _e = useState(false), showConfirmationModal = _e[0], setShowConfirmationModal = _e[1];
    var _f = useState(''), confirmationMessage = _f[0], setConfirmationMessage = _f[1];
    var _g = useState(defaultVoidFunction), handleOkFunction = _g[0], setHandleOkFunction = _g[1];
    var saveJobMutation = useMutation({
        mutationFn: saveCustomerJobs,
        onSuccess: function (_response, _a) {
            var payload = _a[0];
            if ((payload === null || payload === void 0 ? void 0 : payload.is_save) === false) {
                showToast({
                    message: 'Job unsaved successfully.',
                    status: 'success',
                });
                if (handleUpdateJobDetails && !!customerDetail) {
                    handleUpdateJobDetails === null || handleUpdateJobDetails === void 0 ? void 0 : handleUpdateJobDetails(jobDetails.jobId, { isSaved: false });
                }
                else {
                    refetchJobs === null || refetchJobs === void 0 ? void 0 : refetchJobs();
                }
            }
            else {
                showToast({
                    message: 'Job saved successfully.',
                    status: 'success',
                });
                if (handleUpdateJobDetails && !!customerDetail) {
                    handleUpdateJobDetails === null || handleUpdateJobDetails === void 0 ? void 0 : handleUpdateJobDetails(jobDetails.jobId, { isSaved: true });
                }
                else {
                    refetchJobs === null || refetchJobs === void 0 ? void 0 : refetchJobs();
                }
            }
        },
    }).mutate;
    var handleSaveJobs = function (jobId) {
        saveJobMutation([{ job_id: jobId }]);
    };
    var candidateApplyJobMutation = useMutation({
        mutationFn: candidateApplyJob,
        onSuccess: function (_response, _a) {
            var payload = _a[0];
            if ((payload === null || payload === void 0 ? void 0 : payload.is_applied) === false) {
                showToast({
                    message: 'Application withdrawn successfully.',
                    status: 'success',
                });
                if (handleUpdateJobDetails && !!customerDetail) {
                    handleUpdateJobDetails === null || handleUpdateJobDetails === void 0 ? void 0 : handleUpdateJobDetails(jobDetails.jobId, { isApplied: false });
                }
                else {
                    refetchJobs === null || refetchJobs === void 0 ? void 0 : refetchJobs();
                }
            }
            else {
                showToast({
                    message: 'Application submitted successfully.',
                    status: 'success',
                });
                if (handleUpdateJobDetails && !!customerDetail) {
                    handleUpdateJobDetails === null || handleUpdateJobDetails === void 0 ? void 0 : handleUpdateJobDetails(jobDetails.jobId, { isApplied: true });
                }
                else {
                    refetchJobs === null || refetchJobs === void 0 ? void 0 : refetchJobs();
                }
            }
        },
    }).mutate;
    var handleApplyJob = function (jobId) {
        candidateApplyJobMutation([{ job_id: jobId }]);
    };
    var handleShowConfirmationModal = function (message, handleOk) {
        setConfirmationMessage(message);
        setHandleOkFunction(function () { return handleOk; });
        setShowConfirmationModal(true);
    };
    var handleUnSaveJobs = function (jobId) {
        handleShowConfirmationModal('You want to remove this job from your saved jobs?', function () {
            saveJobMutation([{ job_id: jobId, is_save: false }]);
            setShowConfirmationModal(false);
        });
    };
    var handleWithdrawJob = function (jobId) {
        handleShowConfirmationModal('You want to withdraw your application?', function () {
            candidateApplyJobMutation([{ job_id: jobId, is_applied: false }]);
            setShowConfirmationModal(false);
        });
    };
    return (_jsx("a", { href: "/job/".concat(jobDetails.jobId, "/").concat(getJobQuery(jobDetails)), className: 'w-full', rel: 'noreferrer', children: _jsxs("div", { className: 'flex flex-col gap-2 w-full justify-between bg-cardBackgroundSmall text-cardTextColorSmall rounded-lg p-4 shadow-cardBoxShadowSmall hover:shadow-lg transition-shadow border-cardBorderColorSmall border-cardBorderWidthSmall', children: [_jsx("div", { className: 'flex items-baseline gap-1.5', children: _jsx(JobTitleName, __assign({ variant: 'small' }, jobDetails)) }), _jsx("div", { className: 'flex justify-between gap-4', children: _jsxs("div", { className: 'flex flex-col flex-wrap gap-1.5', children: [_jsx(JobMetadata, { variant: 'small', details: jobDetails }), _jsx(SkillsList, { skills: jobDetails.skill, isSkillChipFilterable: true })] }) }), _jsxs("div", { className: 'flex justify-between items-center flex-wrap gap-2 w-full', children: [_jsx("div", { className: 'flex items-center gap-2', children: (jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.jobCreatedDate) || (jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.createdDate) ? (_jsx(DayChip, { variant: 'small', children: _jsx("span", { className: 'flex items-center gap-1 text-nowrap', children: "Created date - ".concat(formatDate(convertUTCDateToLocalDate((jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.jobCreatedDate) || (jobDetails === null || jobDetails === void 0 ? void 0 : jobDetails.createdDate)))) }) })) : null }), _jsx(JobActions, { details: jobDetails, isMyJobs: jobDetails.isApplied, isPublishJobOnlyForVendors: false, handleAppliedJob: handleWithdrawJob, applyJob: handleApplyJob, setApplyModalVisible: setApplyModalVisible, setSaveModalVisible: defaultVoidFunction, saveJob: handleSaveJobs, getBackId: handleUnSaveJobs, setVariableForModal: setVariableForModal, setSelectedJobId: setSelectedJobId, applyButtonVariant: 'primary', saveButtonVariant: 'outline' })] }), variableForModal !== '' && (_jsx(NotRegisteredModal, { isOpen: true, onClose: function () { return setVariableForModal(''); }, variableForModal: variableForModal })), selectedJobId && applyModalVisible && (_jsx(ApplyJobModal, { isOpen: applyModalVisible, onClose: function () { return setApplyModalVisible(false); }, jobId: selectedJobId })), showConfirmationModal && (_jsx(ConformationModal, { isOpen: showConfirmationModal, onClose: function () { return setShowConfirmationModal(false); }, message: confirmationMessage, handleOk: handleOkFunction }))] }) }));
};
